/**
 * Collection explorer: dynamic PLP name from Shape, Origin, Metal.
 * Filtering stays on the current collection via native filter.* params.
 */
(() => {
  if (window.__amadaCollectionExplorerBound) return;
  window.__amadaCollectionExplorerBound = true;

  const HEADING = '[data-amada-explorer-heading]';
  const KEYS = ['shape', 'origin', 'metal'];
  const SHAPE_WORDS = ['round', 'oval', 'emerald', 'princess', 'pear', 'cushion', 'marquise', 'radiant', 'asscher', 'heart'];
  const METAL_WORDS = ['gold', 'platinum', 'palladium', 'silver', 'rose gold', 'white gold', 'yellow gold'];
  const PRIMARY_HINTS = [
    { match: /engagement[- ]rings/, title: 'Engagement Rings' },
    { match: /wedding[- ]rings|eternity[- ]rings/, title: 'Wedding Rings' },
    { match: /tennis[- ]bracelet/, title: 'Tennis Bracelets' },
    { match: /bracelet/, title: 'Bracelets' },
    { match: /earring/, title: 'Earrings' },
    { match: /necklace|pendant/, title: 'Necklaces' },
    { match: /gemstone[- ]ring|^gemstone$/, title: 'Gemstone Rings' },
    { match: /for[- ]him|mens/, title: 'Men’s Jewellery' },
  ];
  const norm = (v) => String(v || '').toLowerCase().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim();
  const handleize = (v) => String(v || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const parse = (id) => {
    const el = document.getElementById(id);
    if (!(el instanceof HTMLElement)) return null;
    try { return JSON.parse(el.textContent || 'null'); } catch { return null; }
  };
  const map = () => parse('amada-collection-explorer-map');
  const state = () => parse('amada-collection-explorer-data');
  const filters = () => parse('amada-collection-explorer-filters') || [];

  function findPrimary(m, handle) {
    if (!m?.primaries || !handle) return null;
    if (m.primaries[handle]) return { handle, config: m.primaries[handle] };
    for (const [h, config] of Object.entries(m.primaries)) {
      if ((config.aliases || []).includes(handle)) return { handle: h, config };
      if ((config.routes || []).some((r) => r.handle === handle)) return { handle: h, config };
    }
    return null;
  }

  function titleFromHandle(handle) {
    const raw = String(handle || '').toLowerCase().replace(/^collections-/, '');
    const spaced = raw.replace(/-/g, ' ');
    for (const hint of PRIMARY_HINTS) {
      if (hint.match.test(raw) || hint.match.test(spaced)) return hint.title;
    }
    return '';
  }

  function context(m, s) {
    const current = s?.currentHandle || '';
    const parent = s?.parentHandle || '';
    const asCurrent = findPrimary(m, current);
    const asParent = findPrimary(m, parent);
    const route = asCurrent?.config?.routes?.find((r) => r.handle === current) || null;
    let primaryHandle = current;
    let primaryTitle = s?.parentTitle || s?.currentTitle || '';
    if (route) {
      primaryHandle = asCurrent.handle;
      primaryTitle = asCurrent.config.title || s?.parentTitle || primaryTitle;
    } else if (asCurrent) {
      primaryHandle = asCurrent.handle;
      primaryTitle = asCurrent.config.title || primaryTitle;
    } else if (asParent) {
      primaryHandle = asParent.handle;
      primaryTitle = asParent.config.title || s?.parentTitle || primaryTitle;
    } else {
      const hinted = titleFromHandle(current) || titleFromHandle(parent);
      if (hinted) primaryTitle = hinted;
    }

    const currentTitle = norm(s?.currentTitle);
    const looksLikeFacet = KEYS.some((key) => {
      const group = (filters() || []).find((f) => f.key === key);
      return (group?.values || []).some((item) => norm(item.label) === currentTitle || norm(item.value) === currentTitle);
    });
    if (looksLikeFacet && norm(primaryTitle) === currentTitle) {
      primaryTitle = titleFromHandle(current) || s?.parentTitle || primaryTitle;
    }
    return { primaryHandle, primaryTitle };
  }

  function addPart(grouped, key, label, value) {
    if (!KEYS.includes(key) || !label) return;
    if (!grouped[key]) grouped[key] = { labels: [], values: [] };
    if (grouped[key].labels.some((v) => norm(v) === norm(label))) return;
    grouped[key].labels.push(label);
    grouped[key].values.push(value);
  }

  function classifyKey(filter, label, value, param) {
    if (filter?.key && KEYS.includes(filter.key)) return filter.key;
    const hay = [param, label, value].map(norm).join(' ');
    if (hay.includes('shape') || SHAPE_WORDS.some((w) => hay === w || hay.includes(w))) return 'shape';
    if (hay.includes('origin') || hay.includes('lab grown') || hay.includes('labgrown') || hay === 'natural' || hay.includes(' natural')) return 'origin';
    if (hay.includes('metal') || hay.includes('material') || METAL_WORDS.some((w) => hay.includes(w))) return 'metal';
    return '';
  }

  function prettyLabel(raw) {
    const text = String(raw || '').replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim();
    if (!text) return '';
    return text.replace(/\b\w/g, (c) => c.toUpperCase()).replace(/\bLab Grown\b/g, 'Lab Grown');
  }

  function findFilter(list, param) {
    return list.find((item) => item.param === param || item.values?.some((e) => e.param === param)) || null;
  }

  function labelFor(filter, value) {
    const match = (filter?.values || []).find((e) => String(e.value) === String(value));
    if (match?.label) return match.label;
    const active = (filter?.activeValues || []).find((e) => String(e.value) === String(value));
    return active?.label || value;
  }


  function fromParams(params, list) {
    const grouped = {};
    for (const [param, value] of params.entries()) {
      if (!param.startsWith('filter.') || param.includes('price')) continue;
      const f = findFilter(list, param);
      const label = labelFor(f, value) || prettyLabel(value);
      const key = classifyKey(f, label, value, param);
      if (!key) continue;
      addPart(grouped, key, label, value);
    }
    return grouped;
  }

  function fromDom(list) {
    const grouped = {};
    document.querySelectorAll('input[name^="filter."]:checked').forEach((input) => {
      if (!(input instanceof HTMLInputElement)) return;
      const param = input.name;
      if (!param.startsWith('filter.') || param.includes('price')) return;
      const f = findFilter(list, param);
      const label = labelFor(f, input.value) || prettyLabel(input.value);
      const key = classifyKey(f, label, input.value, param);
      if (!key) return;
      addPart(grouped, key, label, input.value);
    });
    return grouped;
  }

  function fromChips(list) {
    const grouped = {};
    document.querySelectorAll('.amada-filter-bar__chips facet-remove-component, .facets-remove__pill').forEach((el) => {
      const text = String(el.textContent || '').replace(/\s+/g, ' ').replace(/remove/ig, '').trim();
      if (!text || /^clear/i.test(text)) return;
      const n = norm(text);
      let matched = false;
      for (const f of list) {
        const match = (f.values || []).find((item) => {
          const label = norm(item.label);
          return label && (n === label || n.startsWith(label));
        });
        if (match) {
          const key = classifyKey(f, match.label, match.value, f.param);
          if (key) addPart(grouped, key, match.label, match.value);
          matched = true;
          break;
        }
      }
      if (!matched) {
        const key = classifyKey(null, text, text, '');
        if (key) addPart(grouped, key, prettyLabel(text), text);
      }
    });
    return grouped;
  }

  function fromJson(list) {
    const grouped = {};
    for (const f of list) {
      for (const item of f.activeValues || []) {
        if (!item) continue;
        const key = classifyKey(f, item.label, item.value, f.param);
        if (key) addPart(grouped, key, item.label, item.value);
      }
    }
    return grouped;
  }

  function merge(...groups) {
    const grouped = {};
    for (const group of groups) {
      for (const [key, data] of Object.entries(group || {})) {
        (data.labels || []).forEach((label, i) => addPart(grouped, key, label, data.values?.[i] || label));
      }
    }
    return grouped;
  }

  function withCollectionName(grouped, s, ctx, list) {
    if (!s?.currentHandle) return grouped;
    const title = norm(s.currentTitle);
    const handle = handleize(s.currentHandle).replace(/^collections-/, '');
    const next = { ...grouped };
    for (const f of list) {
      if (!KEYS.includes(f?.key)) continue;
      const match = (f.values || []).find((item) => {
        const label = norm(item.label);
        const value = norm(item.value);
        const labelHandle = handleize(item.label);
        const valueHandle = handleize(item.value);
        if (title && (title === label || title === value)) return true;
        if (handle && (handle === labelHandle || handle === valueHandle)) return true;
        if (labelHandle.length >= 4 && (handle.endsWith('-' + labelHandle) || handle.includes('-' + labelHandle + '-'))) return true;
        if (valueHandle.length >= 4 && (handle.endsWith('-' + valueHandle) || handle.includes('-' + valueHandle + '-'))) return true;
        return false;
      });
      if (match?.label && !next[f.key]) next[f.key] = { labels: [match.label], values: [match.value] };
      else if (match?.label) addPart(next, f.key, match.label, match.value);
    }
    return next;
  }

  function headingText(title, grouped) {
    const parts = [];
    for (const key of KEYS) {
      if (!grouped[key]) continue;
      grouped[key].labels.forEach((label) => { if (label) parts.push(label); });
    }
    const joined = parts.join(' ');
    if (!title) return joined.replace(/\s+/g, ' ').trim();
    if (!joined) return title;
    if (norm(joined).includes(norm(title))) return joined.replace(/\s+/g, ' ').trim();
    return (joined + ' ' + title).replace(/\s+/g, ' ').trim();
  }

  function paint() {
    const m = map();
    const s = state();
    if (!s) return;
    const ctx = context(m, s);
    const list = filters();
    const grouped = withCollectionName(
      merge(fromJson(list), fromParams(new URLSearchParams(window.location.search), list), fromDom(list), fromChips(list)),
      s,
      ctx,
      list
    );
    const title = headingText(ctx.primaryTitle, grouped);
    if (!title) return;
    document.querySelectorAll(HEADING).forEach((n) => {
      if (n.textContent !== title) n.textContent = title;
    });
  }

  let paintTimer = 0;
  function paintSoon() {
    window.clearTimeout(paintTimer);
    paintTimer = window.setTimeout(paint, 80);
  }

  function onCollectionUpdate(event) {
    const promise = event?.detail?.promise;
    if (promise && typeof promise.then === 'function') promise.then(paint).catch(paint);
    paintSoon();
  }

  function onChange(event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) && !(input instanceof HTMLSelectElement)) return;
    const name = input.name || '';
    if (!name.startsWith('filter.') && name !== 'sort_by') return;
    paintSoon();
  }

  function onClick(event) {
    const host = event.target instanceof Element ? event.target.closest('facet-remove-component') : null;
    if (!(host instanceof HTMLElement)) return;
    paintSoon();
  }

  document.addEventListener('change', onChange, true);
  document.addEventListener('click', onClick, true);
  document.addEventListener('shopify:section:load', paintSoon);
  document.addEventListener('collection:update', onCollectionUpdate, true);
  document.addEventListener('shopify:collection:update', onCollectionUpdate, true);
  window.addEventListener('popstate', paintSoon);
  const watch = document.querySelector('.amada-filter-bar, .facets-block-wrapper, [data-amada-active-filters]');
  if (watch && window.MutationObserver) {
    new MutationObserver(paintSoon).observe(watch, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint, { once: true });
  else paint();
})();
